import { RegisterOptions } from 'react-hook-form';
import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';

export const numberWithNoDecimalPattern = /^\s*\d+\s*$/;
export const MAX_MONTHS_LENGTH = 12;
export const MAX_WEEK_LENGTH = 52;
export const MAX_DAYS_LENGTH = 365;

export const getBudgetResetCustomPeriodValidationRules = (
  budgetResetType: BudgetResetTypeValues
): Partial<RegisterOptions> => {
  const limits = {
    [BudgetResetTypeValues.DAYS]: MAX_DAYS_LENGTH,
    [BudgetResetTypeValues.WEEKS]: MAX_WEEK_LENGTH,
    [BudgetResetTypeValues.MONTHS]: MAX_MONTHS_LENGTH,
  };
  const maxLimit = limits[budgetResetType];
  const errorMessage = `Must be a whole number between 1 and ${maxLimit}`;

  return {
    required: 'Required',
    pattern: {
      value: numberWithNoDecimalPattern,
      message: errorMessage,
    },
    validate: (value: string): string | boolean => {
      const numberValue = Number(value);

      const isValidAmount = numberValue > 0 && numberValue <= maxLimit;
      return isValidAmount || errorMessage;
    },
  };
};
